import { Component, OnInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute, Router } from "@angular/router";
import { MatDialog } from "@angular/material/dialog";
import { DataSharingService } from "../../AuthGuard/DataSharingService";
import { ReportsService } from "../services/reports.service";
import { FileCheckingDialogComponent } from "../filechecking-dialog/filechecking-dialog.component";
import { formatDateForExcel } from "../../Shared/date-utils";
import * as moment from "moment";
declare var $: any;

@Component({
  selector: "app-filechecking-ho-report",
  templateUrl: "./filechecking-ho-report.component.html",
  styleUrls: ["./filechecking-ho-report.component.scss"],
  standalone: false
})
export class FilecheckingHoReportComponent implements OnInit {
  showSpinner: boolean = false;
  currentUser: any;

  FromDate: any = new Date();
  ToDate: any = new Date();
  Status: string = "";

  statusOptions: string[] = [
    "Completed",
    "Pending",
    "Before Disbursement",
    "After Disbursement"
  ];

  displayedColumns: string[] = [
    "Id",
    "Application_No",
    "Application_Date",
    "Loan_No",
    "Loan_Date",
    "Customer_Name",
    "Application_LoanAmount",
    "Branch_Name",
    "Product_Name",
    "EMP_Source_Name",
    "Action"
  ];

  DataSource: MatTableDataSource<any>;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  isSearched: boolean = false;
  formatDateForExcel = formatDateForExcel;

  // Detail Modal properties
  detailList: any[] = [];
  selectedLoanNo: string = "";
  selectedAppNo: string = "";
  selectedLoanId: any = null;

  constructor(
    private dataSharingService: DataSharingService,
    private reportsService: ReportsService,
    private route: ActivatedRoute,
    private router: Router,
    public dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    this.dataSharingService.HeaderTitle.next("File Checking HO Report");
  }

  onSearchFileCheckingHoReport(): void {
    this.isSearched = true;
    this.showSpinner = true;

    const fromDateStr = this.FromDate ? moment(this.FromDate).format("YYYY-MM-DD") : "";
    const toDateStr = this.ToDate ? moment(this.ToDate).format("YYYY-MM-DD") : "";

    const reqData = {
      FromDate: fromDateStr,
      ToDate: toDateStr,
      Status: this.Status || ""
    };

    this.reportsService.Get_FileCheckingHo_ReportList(reqData).subscribe({
      next: (res: any) => {
        this.showSpinner = false;
        if (res && res.length > 0) {
          this.DataSource = new MatTableDataSource(res);
          setTimeout(() => {
            if (this.paginator) this.DataSource.paginator = this.paginator;
            if (this.sort) this.DataSource.sort = this.sort;
          });
        } else {
          this.DataSource = new MatTableDataSource([]);
        }
      },
      error: (err: any) => {
        this.showSpinner = false;
        console.error("Error fetching FileChecking HO Report List:", err);
      }
    });
  }

  applyFilter(filterValue: string): void {
    if (this.DataSource) {
      this.DataSource.filter = filterValue.trim().toLowerCase();
    }
  }

  onAction(row: any): void {
    this.selectedLoanNo = row.Loan_No || row.LoanNo || "";
    this.selectedAppNo = row.Application_No || row.ApplicationNo || "";
    this.detailList = [];
    this.showSpinner = true;

    const loanIdVal = (row.Loan_Id !== undefined && row.Loan_Id !== null) ? row.Loan_Id : 
                      ((row.LoanId !== undefined && row.LoanId !== null) ? row.LoanId : 
                      ((row.Loan_ID !== undefined && row.Loan_ID !== null) ? row.Loan_ID : 0));

    this.selectedLoanId = loanIdVal;

    const reqData = {
      LoanId: loanIdVal
    };

    this.reportsService.Get_FileCheckingHo_ReportDetail(reqData).subscribe({
      next: (res: any) => {
        this.showSpinner = false;
        console.log("Get_FileCheckingHo_ReportDetail response:", res);
        if (res && Array.isArray(res)) {
          this.detailList = res;
        } else if (res && Array.isArray(res.data)) {
          this.detailList = res.data;
        } else if (res && Array.isArray(res.Result)) {
          this.detailList = res.Result;
        } else {
          this.detailList = [];
        }
        $("#FileCheckingDetailModal").modal("show");
      },
      error: (err: any) => {
        this.showSpinner = false;
        console.error("Error fetching FileChecking HO Report Detail:", err);
        this.detailList = [];
        $("#FileCheckingDetailModal").modal("show");
      }
    });
  }

  onCloseModal(): void {
    $("#FileCheckingDetailModal").modal("hide");
  }

  openFileCheckingDialog(): void {
    const dialogRef = this.dialog.open(FileCheckingDialogComponent, {
      width: "90vw",
      maxHeight: "90vh",
      panelClass: "filechecking-dialog-container",
      disableClose: true,
      data: { LoanId: this.selectedLoanId },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.onAction({
          Loan_Id: this.selectedLoanId,
          Loan_No: this.selectedLoanNo,
          Application_No: this.selectedAppNo,
        });
      }
    });
  }

  exportexcelNew(): void {
    const uri = "data:application/vnd.ms-excel;base64,";
    const template =
      '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>';
    const base64 = (s: string): string =>
      window.btoa(unescape(encodeURIComponent(s)));
    const format = (s: string, c: { [key: string]: string }): string =>
      s.replace(/{(\w+)}/g, (m, p) => c[p]);

    const table = document.getElementById(
      "export-filechecking-ho"
    ) as HTMLTableElement;
    const worksheetName = "FILE CHECKING HO REPORT";
    const ctx = { worksheet: worksheetName, table: table ? table.innerHTML : "" };
    const fromDateStr = this.FromDate ? moment(this.FromDate).format("DD-MM-YYYY") : "";
    const toDateStr = this.ToDate ? moment(this.ToDate).format("DD-MM-YYYY") : "";
    const downloadLink = document.createElement("a");

    downloadLink.href = uri + base64(format(template, ctx));
    downloadLink.download = `${worksheetName}_${fromDateStr}_To_${toDateStr}.xls`;
    downloadLink.click();
  }
}
